module.exports = __webpack_public_path__ + "img/20220219_130830.eac063aa.jpg";